/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemWithExpiresOnRef,
  LineItemWithExpiresOnRefOptional,
  LineItemWithExpiresOnRefMetaI,
  LineItemWithExpiresOnRefTrackedI,
} from "./line-item-with-expires-on-ref";
import {
  LineItemWithExpiresOnRefTracked,
  LineItemWithExpiresOnRefMeta,
} from "./line-item-with-expires-on-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SignupTypeEnum,
  SignupTypeEnumOptional,
  SignupTypeEnumMetaI,
  SignupTypeEnumTrackedI,
} from "./signup-type-enum";
import { SignupTypeEnumTracked, SignupTypeEnumMeta } from "./signup-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceRef,
  UnifiedClassInstanceRefOptional,
  UnifiedClassInstanceRefMetaI,
  UnifiedClassInstanceRefTrackedI,
} from "./unified-class-instance-ref";
import {
  UnifiedClassInstanceRefTracked,
  UnifiedClassInstanceRefMeta,
} from "./unified-class-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSignupFull,
  UnifiedClassSignupFullOptional,
  UnifiedClassSignupFullMetaI,
  UnifiedClassSignupFullTrackedI,
} from "./unified-class-signup-full";
import {
  UnifiedClassSignupFullTracked,
  UnifiedClassSignupFullMeta,
} from "./unified-class-signup-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassStaggerRef,
  UnifiedClassStaggerRefOptional,
  UnifiedClassStaggerRefMetaI,
  UnifiedClassStaggerRefTrackedI,
} from "./unified-class-stagger-ref";
import {
  UnifiedClassStaggerRefTracked,
  UnifiedClassStaggerRefMeta,
} from "./unified-class-stagger-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithLineItemRef,
  WithLineItemRefOptional,
  WithLineItemRefMetaI,
  WithLineItemRefTrackedI,
} from "./with-line-item-ref";
import {
  WithLineItemRefTracked,
  WithLineItemRefMeta,
} from "./with-line-item-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithStaggerRef,
  WithStaggerRefOptional,
  WithStaggerRefMetaI,
  WithStaggerRefTrackedI,
} from "./with-stagger-ref";
import { WithStaggerRefTracked, WithStaggerRefMeta } from "./with-stagger-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WlResultDTO,
  WlResultDTOOptional,
  WlResultDTOMetaI,
  WlResultDTOTrackedI,
} from "./wl-result-dto";
import { WlResultDTOTracked, WlResultDTOMeta } from "./wl-result-dto";

/**
 *
 * @export
 * @interface ClassSignupDTO
 */
export interface ClassSignupDTOOptional extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof ClassSignupDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof ClassSignupDTO
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof ClassSignupDTO
   */
  signupDatetime?: Date;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof ClassSignupDTO
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ClassSignupDTO
   */
  signupNote?: string;
  /**
   *
   * @type {number}
   * @memberof ClassSignupDTO
   */
  sequence?: number;
  /**
   *
   * @type {PersonRef}
   * @memberof ClassSignupDTO
   */
  personId?: PersonRefOptional;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassSignupDTO
   */
  instanceId?: UnifiedClassInstanceRefOptional;
  /**
   *
   * @type {WlResultDTO}
   * @memberof ClassSignupDTO
   */
  wlResult?: WlResultDTOOptional;
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof ClassSignupDTO
   */
  staggerId?: UnifiedClassStaggerRefOptional;
  /**
   *
   * @type {LineItemWithExpiresOnRef}
   * @memberof ClassSignupDTO
   */
  lineItemId?: LineItemWithExpiresOnRefOptional;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupDTO
   */
  isNew?: boolean;
}

export interface ClassSignupDTO
  extends
    ClassSignupDTOOptional,
    Deletable,
    UnifiedClassSignupFull,
    WithLineItemRef,
    WithStaggerRef {
  /**
   *
   * @type {number}
   * @memberof ClassSignupDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof ClassSignupDTO
   */
  price?: number;
  /**
   *
   * @type {string}
   * @memberof ClassSignupDTO
   */
  signupDatetime?: Date;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof ClassSignupDTO
   */
  signupType?: SignupTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ClassSignupDTO
   */
  signupNote?: string;
  /**
   *
   * @type {number}
   * @memberof ClassSignupDTO
   */
  sequence?: number;
  /**
   *
   * @type {PersonRef}
   * @memberof ClassSignupDTO
   */
  personId: PersonRef;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassSignupDTO
   */
  instanceId?: UnifiedClassInstanceRef;
  /**
   *
   * @type {WlResultDTO}
   * @memberof ClassSignupDTO
   */
  wlResult?: WlResultDTO;
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof ClassSignupDTO
   */
  staggerId?: UnifiedClassStaggerRef;
  /**
   *
   * @type {LineItemWithExpiresOnRef}
   * @memberof ClassSignupDTO
   */
  lineItemId?: LineItemWithExpiresOnRef;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupDTO
   */
  isNew?: boolean;
}

export interface ClassSignupDTOTrackedI extends DeletableOptional {
  /**
   *
   * @type {number}
   * @memberof ClassSignupDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassSignupDTO
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSignupDTO
   */
  signupDatetime?: Date;
  signupDatetimeIsSet: boolean;
  /**
   *
   * @type {SignupTypeEnum}
   * @memberof ClassSignupDTO
   */
  signupType?: SignupTypeEnum;
  signupTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassSignupDTO
   */
  signupNote?: string;
  signupNoteIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassSignupDTO
   */
  sequence?: number;
  sequenceIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof ClassSignupDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
  /**
   *
   * @type {UnifiedClassInstanceRef}
   * @memberof ClassSignupDTO
   */
  instanceId?: UnifiedClassInstanceRefTrackedI;
  instanceIdIsSet: boolean;
  /**
   *
   * @type {WlResultDTO}
   * @memberof ClassSignupDTO
   */
  wlResult?: WlResultDTOTrackedI;
  wlResultIsSet: boolean;
  /**
   *
   * @type {UnifiedClassStaggerRef}
   * @memberof ClassSignupDTO
   */
  staggerId?: UnifiedClassStaggerRefTrackedI;
  staggerIdIsSet: boolean;
  /**
   *
   * @type {LineItemWithExpiresOnRef}
   * @memberof ClassSignupDTO
   */
  lineItemId?: LineItemWithExpiresOnRefTrackedI;
  lineItemIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassSignupDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
}

transformDatesMap.set("ClassSignupDTO", function (model: ClassSignupDTO) {
  if (typeof model.signupDatetime == "string")
    model.signupDatetime = new Date(model.signupDatetime);
  const transformDatespersonId = transformDatesMap.get("PersonRef");
  if (transformDatespersonId && model.personId) {
    transformDatespersonId(model.personId);
  }
  const transformDatesinstanceId = transformDatesMap.get(
    "UnifiedClassInstanceRef",
  );
  if (transformDatesinstanceId && model.instanceId) {
    transformDatesinstanceId(model.instanceId);
  }
  const transformDateswlResult = transformDatesMap.get("WlResultDTO");
  if (transformDateswlResult && model.wlResult) {
    transformDateswlResult(model.wlResult);
  }
  const transformDatesstaggerId = transformDatesMap.get(
    "UnifiedClassStaggerRef",
  );
  if (transformDatesstaggerId && model.staggerId) {
    transformDatesstaggerId(model.staggerId);
  }
  const transformDateslineItemId = transformDatesMap.get(
    "LineItemWithExpiresOnRef",
  );
  if (transformDateslineItemId && model.lineItemId) {
    transformDateslineItemId(model.lineItemId);
  }
});

export type ClassSignupDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  signupDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  signupType: PropertyMeta<SignupTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  signupNote: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sequence: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<UnifiedClassInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  wlResult: PropertyMeta<WlResultDTOMetaI>;
  //isDate: false
  //isDatetime: false
  staggerId: PropertyMeta<UnifiedClassStaggerRefMetaI>;
  //isDate: false
  //isDatetime: false
  lineItemId: PropertyMeta<LineItemWithExpiresOnRefMetaI>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var ClassSignupDTOMeta: ClassSignupDTOMetaI = {} as ClassSignupDTOMetaI;
ClassSignupDTOMeta = typeMeta("ClassSignupDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  signupDatetime: propertyMeta(
    "signupDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  signupType: propertyMeta(
    "signupType",
    false,
    false,
    false,
    SignupTypeEnumMeta,
  ),
  signupNote: propertyMeta(
    "signupNote",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sequence: propertyMeta("sequence", false, false, false, MetaTypesBase.number),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
  instanceId: propertyMeta(
    "instanceId",
    false,
    false,
    false,
    UnifiedClassInstanceRefMeta,
  ),
  wlResult: propertyMeta("wlResult", false, false, false, WlResultDTOMeta),
  staggerId: propertyMeta(
    "staggerId",
    false,
    false,
    false,
    UnifiedClassStaggerRefMeta,
  ),
  lineItemId: propertyMeta(
    "lineItemId",
    false,
    false,
    false,
    LineItemWithExpiresOnRefMeta,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
});

const metaI = ClassSignupDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([UnifiedClassSignupFullMeta]);
  metaI.assignId.inheritedFrom = UnifiedClassSignupFullMeta.assignId;
  metaI.price.inheritedFrom = UnifiedClassSignupFullMeta.price;
  metaI.signupDatetime.inheritedFrom =
    UnifiedClassSignupFullMeta.signupDatetime;
  metaI.signupType.inheritedFrom = UnifiedClassSignupFullMeta.signupType;
  metaI.signupNote.inheritedFrom = UnifiedClassSignupFullMeta.signupNote;
  metaI.sequence.inheritedFrom = UnifiedClassSignupFullMeta.sequence;
  metaI.personId.inheritedFrom = UnifiedClassSignupFullMeta.personId;
  metaI.instanceId.inheritedFrom = UnifiedClassSignupFullMeta.instanceId;
  metaI.wlResult.inheritedFrom = UnifiedClassSignupFullMeta.wlResult;
  metaI.interfaces = metaI.interfaces.concat([WithStaggerRefMeta]);
  metaI.staggerId.inheritedFrom = WithStaggerRefMeta.staggerId;
  metaI.interfaces = metaI.interfaces.concat([WithLineItemRefMeta]);
  metaI.lineItemId.inheritedFrom = WithLineItemRefMeta.lineItemId;
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
});

export class ClassSignupDTOTracked
  extends DeletableTracked
  implements ClassSignupDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  signupDatetime__I?: Date = undefined;
  signupDatetimeIsSet: boolean = false;
  set signupDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.signupDatetime__I = v;
      this.signupDatetimeIsSet = true;
    } else {
      this.signupDatetime__I = v || undefined;
      this.signupDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupDatetime() {
    return this.signupDatetime__I;
  }
  signupType__I?: SignupTypeEnum = undefined;
  signupTypeIsSet: boolean = false;
  set signupType(v: undefined | SignupTypeEnum) {
    if (v !== undefined) {
      this.signupType__I = v;
      this.signupTypeIsSet = true;
    } else {
      this.signupType__I = v || undefined;
      this.signupTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupType() {
    return this.signupType__I;
  }
  signupNote__I?: string = undefined;
  signupNoteIsSet: boolean = false;
  set signupNote(v: undefined | string) {
    if (v !== undefined) {
      this.signupNote__I = v;
      this.signupNoteIsSet = true;
    } else {
      this.signupNote__I = v || undefined;
      this.signupNoteIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupNote() {
    return this.signupNote__I;
  }
  sequence__I?: number = undefined;
  sequenceIsSet: boolean = false;
  set sequence(v: undefined | number) {
    if (v !== undefined) {
      this.sequence__I = v;
      this.sequenceIsSet = true;
    } else {
      this.sequence__I = v || undefined;
      this.sequenceIsSet = false;
    }
    this.changeTracker = true;
  }
  get sequence() {
    return this.sequence__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  instanceId__I?: UnifiedClassInstanceRefTracked = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | UnifiedClassInstanceRefTracked) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  wlResult__I?: WlResultDTOTracked = undefined;
  wlResultIsSet: boolean = false;
  set wlResult(v: undefined | WlResultDTOTracked) {
    if (v !== undefined) {
      this.wlResult__I = v;
      this.wlResultIsSet = true;
    } else {
      this.wlResult__I = v || undefined;
      this.wlResultIsSet = false;
    }
    this.changeTracker = true;
  }
  get wlResult() {
    return this.wlResult__I;
  }
  staggerId__I?: UnifiedClassStaggerRefTracked = undefined;
  staggerIdIsSet: boolean = false;
  set staggerId(v: undefined | UnifiedClassStaggerRefTracked) {
    if (v !== undefined) {
      this.staggerId__I = v;
      this.staggerIdIsSet = true;
    } else {
      this.staggerId__I = v || undefined;
      this.staggerIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get staggerId() {
    return this.staggerId__I;
  }
  lineItemId__I?: LineItemWithExpiresOnRefTracked = undefined;
  lineItemIdIsSet: boolean = false;
  set lineItemId(v: undefined | LineItemWithExpiresOnRefTracked) {
    if (v !== undefined) {
      this.lineItemId__I = v;
      this.lineItemIdIsSet = true;
    } else {
      this.lineItemId__I = v || undefined;
      this.lineItemIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get lineItemId() {
    return this.lineItemId__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  constructor(config?: ClassSignupDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personId?.setIds();

    this.instanceId?.setIds();

    this.wlResult?.setIds();

    this.staggerId?.setIds();

    this.lineItemId?.setIds();
  }
  assignFrom(
    config: ClassSignupDTOOptional,
    options?: AssignOptions,
  ): ClassSignupDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (
      config.signupDatetime &&
      this.signupDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.signupDatetime = config.signupDatetime;
      if (optionsRequired.unassign) this.signupDatetimeIsSet = false;
      else this.signupDatetimeIsSet = true;
    }
    if (
      config.signupType &&
      this.signupTypeApplyFilter(optionsRequired.filter)
    ) {
      this.signupType = config.signupType;
      if (optionsRequired.unassign) this.signupTypeIsSet = false;
      else this.signupTypeIsSet = true;
    }
    if (
      config.signupNote &&
      this.signupNoteApplyFilter(optionsRequired.filter)
    ) {
      this.signupNote = config.signupNote;
      if (optionsRequired.unassign) this.signupNoteIsSet = false;
      else this.signupNoteIsSet = true;
    }
    if (config.sequence && this.sequenceApplyFilter(optionsRequired.filter)) {
      this.sequence = config.sequence;
      if (optionsRequired.unassign) this.sequenceIsSet = false;
      else this.sequenceIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = new UnifiedClassInstanceRefTracked(
        config.instanceId,
        options,
      );
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (config.wlResult && this.wlResultApplyFilter(optionsRequired.filter)) {
      this.wlResult = new WlResultDTOTracked(config.wlResult, options);
      if (optionsRequired.unassign) this.wlResultIsSet = false;
      else this.wlResultIsSet = true;
    }
    if (config.staggerId && this.staggerIdApplyFilter(optionsRequired.filter)) {
      this.staggerId = new UnifiedClassStaggerRefTracked(
        config.staggerId,
        options,
      );
      if (optionsRequired.unassign) this.staggerIdIsSet = false;
      else this.staggerIdIsSet = true;
    }
    if (
      config.lineItemId &&
      this.lineItemIdApplyFilter(optionsRequired.filter)
    ) {
      this.lineItemId = new LineItemWithExpiresOnRefTracked(
        config.lineItemId,
        options,
      );
      if (optionsRequired.unassign) this.lineItemIdIsSet = false;
      else this.lineItemIdIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassSignupDTOTrackedI {
    const cloned = {} as ClassSignupDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.signupDatetimeIsSetDeep() &&
      this.signupDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupDatetimeIsSet = true;
      cloned.signupDatetime = this.signupDatetime;
    } else {
      //cloned.signupDatetimeIsSet = false
    }
    if (
      this.signupTypeIsSetDeep() &&
      this.signupTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupTypeIsSet = true;
      cloned.signupType = this.signupType;
    } else {
      //cloned.signupTypeIsSet = false
    }
    if (
      this.signupNoteIsSetDeep() &&
      this.signupNoteApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupNoteIsSet = true;
      cloned.signupNote = this.signupNote;
    } else {
      //cloned.signupNoteIsSet = false
    }
    if (
      this.sequenceIsSetDeep() &&
      this.sequenceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sequenceIsSet = true;
      cloned.sequence = this.sequence;
    } else {
      //cloned.sequenceIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId?.removeUnset(filter);
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.wlResultIsSetDeep() &&
      this.wlResultApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.wlResultIsSet = true;
      cloned.wlResult = this.wlResult?.removeUnset(filter);
    } else {
      //cloned.wlResultIsSet = false
    }
    if (
      this.staggerIdIsSetDeep() &&
      this.staggerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.staggerIdIsSet = true;
      cloned.staggerId = this.staggerId?.removeUnset(filter);
    } else {
      //cloned.staggerIdIsSet = false
    }
    if (
      this.lineItemIdIsSetDeep() &&
      this.lineItemIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lineItemIdIsSet = true;
      cloned.lineItemId = this.lineItemId?.removeUnset(filter);
    } else {
      //cloned.lineItemIdIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassSignupDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.signupDatetimeApplyFilter(filter))
      this.signupDatetimeIsSet = false;

    if (!this.signupTypeApplyFilter(filter)) this.signupTypeIsSet = false;

    if (!this.signupNoteApplyFilter(filter)) this.signupNoteIsSet = false;

    if (!this.sequenceApplyFilter(filter)) this.sequenceIsSet = false;

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;
    this.instanceId?.unassignAll(filter);

    if (!this.wlResultApplyFilter(filter)) this.wlResultIsSet = false;
    this.wlResult?.unassignAll(filter);

    if (!this.staggerIdApplyFilter(filter)) this.staggerIdIsSet = false;
    this.staggerId?.unassignAll(filter);

    if (!this.lineItemIdApplyFilter(filter)) this.lineItemIdIsSet = false;
    this.lineItemId?.unassignAll(filter);

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.assignId,
      ClassSignupDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.price,
      ClassSignupDTOMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  signupDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.signupDatetime,
      ClassSignupDTOMeta,
      this.signupDatetime,
      this,
    );
  }
  signupDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupDatetimeIsSet && this.signupDatetimeApplyFilter(filter))
      return true;

    return false;
  }
  signupTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.signupType,
      ClassSignupDTOMeta,
      this.signupType,
      this,
    );
  }
  signupTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupTypeIsSet && this.signupTypeApplyFilter(filter)) return true;

    return false;
  }
  signupNoteApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.signupNote,
      ClassSignupDTOMeta,
      this.signupNote,
      this,
    );
  }
  signupNoteIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupNoteIsSet && this.signupNoteApplyFilter(filter)) return true;

    return false;
  }
  sequenceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.sequence,
      ClassSignupDTOMeta,
      this.sequence,
      this,
    );
  }
  sequenceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sequenceIsSet && this.sequenceApplyFilter(filter)) return true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.personId,
      ClassSignupDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.instanceId,
      ClassSignupDTOMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;
    return this.instanceId?.anySet(filter) == true;

    return false;
  }
  wlResultApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.wlResult,
      ClassSignupDTOMeta,
      this.wlResult,
      this,
    );
  }
  wlResultIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.wlResultIsSet && this.wlResultApplyFilter(filter)) return true;
    return this.wlResult?.anySet(filter) == true;

    return false;
  }
  staggerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.staggerId,
      ClassSignupDTOMeta,
      this.staggerId,
      this,
    );
  }
  staggerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.staggerIdIsSet && this.staggerIdApplyFilter(filter)) return true;
    return this.staggerId?.anySet(filter) == true;

    return false;
  }
  lineItemIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.lineItemId,
      ClassSignupDTOMeta,
      this.lineItemId,
      this,
    );
  }
  lineItemIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lineItemIdIsSet && this.lineItemIdApplyFilter(filter)) return true;
    return this.lineItemId?.anySet(filter) == true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.isDeleted,
      ClassSignupDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassSignupDTOMeta.isNew,
      ClassSignupDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.signupDatetimeIsSetDeep(filter)) return true;
    if (this.signupTypeIsSetDeep(filter)) return true;
    if (this.signupNoteIsSetDeep(filter)) return true;
    if (this.sequenceIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.wlResultIsSetDeep(filter)) return true;
    if (this.staggerIdIsSetDeep(filter)) return true;
    if (this.lineItemIdIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
